import { useEffect, useState, useCallback } from "react";
import { fetchRescheduleDetails } from "../service";
import DivSpinner from "../../../components/divSpinner";
import ModalTemplate from "../../../components/modal/modalTemplate";
import { formatHHMM, timestampToDate } from "../../../utils";

const LoadingComponent = () => (
    <div style={{ height: `${window.innerHeight - 387}px` }}>
        <DivSpinner />
    </div>
);

const RescheduleDetails = ({ job_id, show, handleClose }) => {
    const [loading, setLoading] = useState(false);
    const [details, setDetails] = useState(null);

    const getRescheduleDetails = useCallback(async () => {
        if (!job_id || !show) return;

        try {
            setLoading(true);
            const response = await fetchRescheduleDetails(job_id);
            if (response?.status === "Success") {
                setDetails(response.details);
            }
        } catch (error) {
            console.error("Reschedule details fetch error:", error);
        } finally {
            setLoading(false);
        }
    }, [job_id, show]);

    useEffect(() => {
        getRescheduleDetails();
    }, [getRescheduleDetails]);

    const isApproved = details?.reschedule_job_customer_is_approval === 1;

    return (
        <ModalTemplate
            show={show}
            closeFun={handleClose}
            centered
            title="Reschedule job details"
            body={
                loading ? (
                    <LoadingComponent />
                ) : (
                    details && (
                        <div className="card">
                            <div className="card-body py-3">
                                <div className="d-flex">
                                    <i
                                        className={`material-icons text-${isApproved ? "success" : "danger"}`}
                                        style={{ fontSize: 40 }}
                                    >
                                        {isApproved ? "check_circle" : "cancel"}
                                    </i>

                                    <div className="ms-2 my-auto">
                                        <h6 className="mb-0">
                                            {isApproved ? "Accepted" : "Rejected"}
                                        </h6>
                                        <p className="text-xs mb-0">
                                            #{details.reschedule_job_id}
                                        </p>
                                    </div>
                                </div>

                                <p className="mb-0 text-sm mt-2">
                                    {details.reschedule_description}
                                </p>

                                <p className="mb-0 mt-2">
                                    <b>Request ETA:</b>{" "}
                                    {timestampToDate(details.reschedule_job_start_timestamp)}{" "}
                                    {formatHHMM(details.reschedule_job_start_timestamp)} to{" "}
                                    {formatHHMM(details.reschedule_job_end_timestamp)}
                                </p>
                            </div>

                            <hr className="dark horizontal my-0" />

                            <div className="card-footer d-flex justify-content-between align-items-center py-3">
                                <div className="d-flex align-items-center">
                                    <i className="material-icons text-lg me-1">home_work</i>
                                    <p className="text-sm my-auto">Job ID</p>
                                </div>
                                <p className="fw-bold text-dark my-auto text-sm">
                                    #{details.reschedule_job_job_id}
                                </p>
                            </div>
                        </div>
                    )
                )
            }
            footer={null}
        />
    );
};

export default RescheduleDetails;